import { PhotosActionTypes } from '../types';
import { makeAsyncActionCreators } from '../../helpers';

const fetchPhotosAndResources = makeAsyncActionCreators(
  PhotosActionTypes.fetchPhotosAndResources,
  ['userId', 'projectId'],
  ['photos', 'project', 'chapters', 'book'],
  ['error'],
);

const addPhotoByProjectId = makeAsyncActionCreators(
  PhotosActionTypes.addPhotoByProjectId,
  ['projectId', 'photo'],
  ['photos', 'book'],
  ['error'],
);

const addMultiplePhotos = makeAsyncActionCreators(
  PhotosActionTypes.addMultiplePhotos,
  ['projectId', 'photos'],
  ['photos', 'book'],
  ['error'],
);

const updateMultiplePhotos = makeAsyncActionCreators(
  PhotosActionTypes.updateMultiplePhotos,
  ['photos', 'silentNotificationMode'],
  ['photos', 'book'],
  ['error'],
);

const updatePhoto = makeAsyncActionCreators(
  PhotosActionTypes.updatePhoto,
  ['photoId', 'photo', 'objectPositionAndZoom'],
  ['photo', 'book'],
  ['error'],
);

const deletePhotoWithIndexShifting = makeAsyncActionCreators(
  PhotosActionTypes.deletePhotoWithIndexShifting,
  ['photoId'],
  ['removedPhoto', 'chapterPhotos'],
  ['error'],
);

const sendPhotosUploadInfo = makeAsyncActionCreators(
  PhotosActionTypes.sendPhotosUploadInfo,
  ['projectId', 'photosCount', 'captionsCount'],
  ['book'],
  ['error'],
);

const replaceCoverPhoto = makeAsyncActionCreators(
  PhotosActionTypes.replaceCoverPhoto,
  ['photo'],
  ['photos', 'book'],
  ['error'],
);

const chooseCoverPhoto = makeAsyncActionCreators(
  PhotosActionTypes.chooseCoverPhoto,
  ['projectId'],
  ['photos', 'book'],
  ['error'],
);

const getCoverPhotosByProjectId = makeAsyncActionCreators(
  PhotosActionTypes.getCoverPhotosByProjectId,
  ['projectId'],
  ['photos'],
  ['error'],
);

const getCoverPhotos = makeAsyncActionCreators(
  PhotosActionTypes.getCoverPhotos,
  [],
  ['photos'],
  ['error'],
);

const deleteCoverPhotos = makeAsyncActionCreators(
  PhotosActionTypes.deleteCoverPhotos,
  ['photoIds'],
  ['photo', 'book'],
  ['error'],
);

const addCoverPhoto = makeAsyncActionCreators(
  PhotosActionTypes.addCoverPhoto,
  ['projectId', 'photo'],
  ['photos', 'book'],
  ['error'],
);

export default {
  replaceCoverPhoto,
  fetchPhotosAndResources,
  addPhotoByProjectId,
  addMultiplePhotos,
  updateMultiplePhotos,
  updatePhoto,
  deletePhotoWithIndexShifting,
  sendPhotosUploadInfo,
  chooseCoverPhoto,
  getCoverPhotosByProjectId,
  getCoverPhotos,
  deleteCoverPhotos,
  addCoverPhoto,
};
